module.exports = __webpack_public_path__ + "analytics-graphic.dd647d.svg";